export const API_BASE = '/api/prp-delegator/';
export const API_BASE_LOCAL = 'http://localhost:8080/prp-delegator/';

export const STARTING_POINT_DELEGATOR_URL = '/sp/process-request';
export const PDF_URL = '/sp/results-pdf';
export const SHOW_SEND_RESULTS_INFO_URL = '/prp/show-send-results';

export const STARTING_POINT_APP_NAME_FRENCH = 'pointdedepart';

export const LOCALE_EN_US = 'en_US';
export const LOCALE_EN_CA = 'en_CA';
export const LOCALE_FR_CA = 'fr_CA';
